import Plot from "react-plotly.js";

export default function XaiPlot({ x, y, c1, c2 }) {
    return (
        <Plot
            className="Plot"
            data={[
                {
                    x: x,
                    y: y,
                    fill: "tozeroy",
                    fillpattern: { shape: "/" },
                    name: "Raw Raman Spectrum",
                    mode: "lines",
                    line: {
                        color: "#4C566A"
                    }
                },
                {
                    x: x,
                    y: c1,
                    fill: "tozeroy",
                    name: "Most Significant Segment",
                    mode: "lines",
                    line: {
                        color: "#ef5350"
                    }
                },
                {
                    x: x,
                    y: c2,
                    fill: "tozeroy",
                    name: "Second Most Significant Segment",
                    mode: "lines",
                    line: {
                        color: "#7e57c2"
                    }
                },
            ]}
            config={{ responsive: true, staticPlot: true }}
            layout={{
                paper_bgcolor: "#00000000",
                plot_bgcolor: "#00000000",
                legend: {
                    x: 0.0,
                    y: 1.0,
                },
                showlegend: true,
                xaxis: {
                    visible: true,
                    showgrid: false,
                    zeroline: false,
                    title: "Raman Shift",
                },
                yaxis: { visible: false },
                margin: {
                    l: 0,
                    r: 0,
                    b: 50,
                    t: 50,
                    pad: 0,
                },
                title: "Interpretation of the Model",
                font: {
                    family: "Sans-Serif",
                    size: 18,
                    color: "#7f7f7f",
                },
            }}
        ></Plot>
    );
}
